"use client";

import { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { ArrowRight, ExternalLink } from "lucide-react";
import Button from '@/components/CommonComponent/button'
import { div } from "framer-motion/client";
const PortfolioSlider = ({ props }: any) => {
  return (
    <div className="w-full lg:w-[95%] 2xl:w-[80%] mx-auto px-4 py-8">
      <SectionSlider section={props} />
    </div>
  );
};

const SectionSlider = ({ section }: any) => {
  const [visibleCount, setVisibleCount] = useState(3);

  const handleViewMore = () => {
    setVisibleCount((prev) => prev + 6);
  };

  return (
    <div className="mb-12 w-full">
      <div className="flex justify-between border-b-2 pb-2 border-slate-300 items-center mb-6">
        <h2 className="text-homeblack">{section.title}</h2>
       
      </div>

      <div className="flex justify-center flex-wrap gap-5">
  {section?.card?.slice(0, visibleCount).map((card: any) =>
    card.traffic_growth || card.user_engagement || card.conversion_rate || card.monthly_visitors ? (
      <PortfolioCard key={card.slug} card={card} />
    ) : (
      <PortfolioCard1 key={card.slug} card={card} />
    )
  )}
</div>

      {visibleCount < section.card.length && (
        <div className="w-full flex justify-center  mt-10">

        
         <div onClick={handleViewMore} className="">
          <Button  content="View More Case Study"/>
          </div>
         </div>
        )}
    </div>
  );
};

const PortfolioCard = ({ card }: any) => {
  return (
    <div className="max-w-[464px] mt-8 border-t-[1px] border-slate-200 lg:w-[32%] sm:w-[47%] h-inherit p-3 bg-white rounded-xl overflow-hidden shadow-md">
      <div>
        <Image
          src={card.image || ""}
          alt={card.image_alt || card.title}
          width={450}
          height={214}
          className="rounded-xl max-h-[214px]"
        />
      </div>
      <div className="p-4">
        <h3 className="font-bold my-3">{card.title}</h3>
        <div className="grid grid-cols-2 gap-3 mb-4">
          {card?.traffic_growth && (
            <div className="flex flex-col bg-grey p-2 rounded-lg">
              <span
                className="font-bold"
                dangerouslySetInnerHTML={{ __html: card.traffic_growth }}
              />
            </div>
          )}
          {card?.user_engagement && (
            <div className="flex flex-col bg-grey p-2 rounded-lg">
              <span
                className="font-bold"
                dangerouslySetInnerHTML={{ __html: card.user_engagement }}
              />
            </div>
          )}
          {card?.monthly_visitors && (
            <div className="flex flex-col bg-grey p-2 rounded-lg">
              <span
                className="font-bold"
                dangerouslySetInnerHTML={{ __html: card.monthly_visitors }}
              />
            </div>
          )}
          {card?.conversion_rate && (
            <div className="flex flex-col bg-grey p-2 rounded-lg">
              <span
                className="font-bold"
                dangerouslySetInnerHTML={{ __html: card.conversion_rate }}
              />
            </div>
          )}
        </div>
        <Link
          href={`/case-studies/${card.slug}`}
          className="inline-flex items-center duration-300 hover:text-pink p-3 text-white bg-pink hover:bg-lightpink px-3 py-1.5 rounded"
        >
          View Case Study <ArrowRight className="ml-1 w-4 h-4" />
        </Link>
      </div>
    </div>
  );
};
const PortfolioCard1 = ({ card }: any) => {
  return (
    <div
    className='w-[455px] sm:max-w-[45%] rounded-xl md:max-w-[31%] group relative'
  >
    <div className='w-full  border-2 border-lightblue h-[301px] rounded-xl relative overflow-hidden'>
      <Image
        src={card.image} // Use the actual image URL from the study data
        height={301}
        width={455}
        alt={card?.image_alt} // Adding alt text for accessibility
        className='rounded-xl w-full h-full'
      />
      <div className='w-full h-full bg-white/30 absolute rounded-xl top-0 left-0 flex items-center justify-center transition-opacity duration-300 opacity-0 group-hover:opacity-100'>
        <div className='absolute translate-y-100 transition-transform duration-300 transform translate-y-full group-hover:translate-y-0'>
          <Link href={`/case-studies/${card?.slug}`}>
            <Button content={"View"} />
          </Link>
        </div>
      </div>
    </div>
    <div>
      <p className='text-center text-[22px] mt-3 uppercase font-semibold'>{card?.title}</p>
    </div>
  </div>
  );
};

export default PortfolioSlider;
